import { CSSObject, styled, lighten } from '@mui/material';

import { TableCell, TableCellProps } from '@occc-app/design-system';

type TransactionViewTableCellProps = {
  noBottomBorder?: boolean;
  noHorizontalPadding?: boolean;
  noVerticalPadding?: boolean;
  isLeftRadius?: boolean;
  isRightRadius?: boolean;
  isHighlighted?: boolean;
} & TableCellProps;

export const TransactionViewTableCell = styled(TableCell, {
  shouldForwardProp: (propName: string) =>
    ![
      'noBottomBorder',
      'noHorizontalPadding',
      'noVerticalPadding',
      'isLeftRadius',
      'isRightRadius',
      'isHighlighted',
    ].includes(propName),
})<TransactionViewTableCellProps>(
  ({
    theme,
    noBottomBorder,
    noHorizontalPadding,
    noVerticalPadding,
    isLeftRadius,
    isRightRadius,
    isHighlighted,
  }) => {
    let css: CSSObject = {
      borderBottom: noBottomBorder ? 'none' : undefined,
    };

    if (isLeftRadius) {
      css = {
        ...css,
        '&:first-of-type': {
          borderTopLeftRadius: theme.spacing(1),
          borderBottomLeftRadius: theme.spacing(1),
          padding: 0,
        },
      };
    }

    if (isRightRadius) {
      css = {
        ...css,
        '&:last-of-type': {
          borderTopRightRadius: theme.spacing(1),
          borderBottomRightRadius: theme.spacing(1),
          padding: 0,
        },
      };
    }

    if (isHighlighted) {
      css = {
        ...css,
        backgroundColor: lighten(theme.palette.primary.main, 0.9),
      };
    }

    if (noHorizontalPadding) {
      css = {
        ...css,
        paddingLeft: '0',
        paddingRight: '0',
        '&:first-of-type': { paddingLeft: '0', paddingRight: '0' },
        '&:last-of-type': { paddingLeft: '0', paddingRight: '0' },
      };
    }

    if (noVerticalPadding) {
      css = {
        ...css,
        paddingTop: '0',
        paddingBottom: '0',
      };
    }

    return css;
  },
);
